<template>
  <div id="app">
    <el-container v-bind:direction="'vertical'">
      <Header v-if="$route.path !== '/'"></Header>
      <router-view/>
      <Footer v-if="$route.path !== '/'"></Footer>
    </el-container>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header: Header,
    Footer: Footer
  }
}
</script>

<style>
h1, h2, h3 {
  margin-block: 0;
  margin-inline: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-container {
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue